export function isBlank(value) {
  return String(value || "").trim().length === 0;
}

export function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
}

export function isValidPhone(value) {
  return /^[0-9 ()+-]+$/.test(String(value || "").trim());
}
